import { object, string } from "yup";
import { REQUIRED_MESSAGE } from "../constants/login";
// import { EMAIL_REGEX } from "../constants/regularExpressions";

export const LoginSchema = object({
  // email: string().required(REQUIRED_MESSAGE).matches(EMAIL_REGEX), //para agregar validación de correo
  email: string().required(REQUIRED_MESSAGE),
  password: string().required(REQUIRED_MESSAGE),
});
